/**
 * Thin fetch wrapper that auto-attaches the Bearer session token.
 * All requests hit the platform-api worker at VITE_WORKER_API_URL.
 */

import { readSessionToken } from './auth';

const API_URL =
  (import.meta.env as Record<string, string>).VITE_WORKER_API_URL ||
  'https://clarity-platform-api.ryan-dc4.workers.dev';

export const AI_CTO_URL =
  (import.meta.env as Record<string, string>).VITE_AI_CTO_URL ||
  'https://clarity-ai-cto.ryan-dc4.workers.dev';

function authHeaders(): Record<string, string> {
  const token = readSessionToken();
  return token ? { authorization: `Bearer ${token}` } : {};
}

export async function apiGet<T>(path: string): Promise<T> {
  const res = await fetch(`${API_URL}${path}`, {
    headers: { ...authHeaders() },
  });
  if (!res.ok) {
    const text = await res.text().catch(() => res.statusText);
    throw new Error(`GET ${path} failed ${res.status}: ${text}`);
  }
  return res.json() as Promise<T>;
}

export async function apiPatch<T>(path: string, body: unknown): Promise<T> {
  const res = await fetch(`${API_URL}${path}`, {
    method: 'PATCH',
    headers: {
      ...authHeaders(),
      'content-type': 'application/json',
    },
    body: JSON.stringify(body),
  });
  if (!res.ok) {
    const text = await res.text().catch(() => res.statusText);
    throw new Error(`PATCH ${path} failed ${res.status}: ${text}`);
  }
  return res.json() as Promise<T>;
}
